import { render, staticRenderFns } from "./InventoryCreation.vue?vue&type=template&id=4042a619&scoped=true&lang=pug&"
import script from "./InventoryCreation.vue?vue&type=script&lang=js&"
export * from "./InventoryCreation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4042a619",
  null
  
)

export default component.exports